<template>
  <div>
    <div class="position-relative mb-3">
      <div class="position-relative mb-3">
        <section class="section-profile-cover section-shaped my-0">
          <div
            class="shape shape-style-1 bg-gradient-navyDark shape-skew alpha-4"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </section>
        <section class="section-skew">
          <div class="container-section">
            <card shadow class="section-home">
              <div class="row row-grid align-items-center">
                <div
                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
                >
                  <div v-if="isLoading" class="loading-spinner">
                    <div class="circle"></div>
                  </div>

                  <div v-if="!isLoading" class="img-main-post">
                    <img :src="post.coverUrl" alt="Post Image" />
                  </div>
                </div>
              </div>
            </card>
          </div>
        </section>
      </div>
      <div v-if="isLoading" class="loading-spinner">
        <div class="circle"></div>
      </div>
    </div>
    <section class="section-skew" v-if="!isLoading">
      <div class="container-section">
        <div class="title-details-post">
          <h3>{{ post.title }}</h3>
        </div>
        <div class="date-details-post">
          <h6>
            <span>نویسنده:</span>
            {{ post.authorName }}
          </h6>
          <h6>
            <span>نوشته شده در:</span>
            {{ post.date }}
          </h6>
        </div>
        <div class="subtitle-details-post">
          <h6>{{ post.subtitle }}</h6>
        </div>
        <div class="subtitle-details-post">
          <h6>{{ post.preface }}</h6>
        </div>
        <div
          v-for="(block, index) in post.blocks"
          :key="index"
          class="post-block"
        >
          <div class="row row-grid">
            <div
              class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
            >
              <p class="content-block">{{ block.content }}</p>
            </div>
            <div
              class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
            >
              <div class="img-block">
                <img
                  v-if="block.fileUrl"
                  :src="block.fileUrl"
                  :alt="block.fileAltText"
                />
              </div>
              <div class="fileAltText-block">
                <p>{{ block.fileAltText }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="categories-block">
          <h6>دسته‌بندی‌ها</h6>

          <span
            v-for="(category, index) in post.categoryIds"
            :key="index"
            @click="goToCategoryPosts(category.id)"
          >
            {{ category.name }}
          </span>
        </div>
        <div class="tage-block">
          <h6>برچسب‌ها</h6>

          <span
            v-for="(tag, index) in post.tags"
            :key="index"
            @click="goToTagPosts(tag)"
          >
            {{ tag }}
          </span>
        </div>
      </div>
    </section>

    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "DetailsBlog",
  data() {
    return {
      showScrollButton: false,
      isLoading: true,
      post: {},
    };
  },
  methods: {
    async fetchPostDetails() {
      const postId = this.$route.params.id;
      const apiUrl = this.$baseUrl + `/v1/post/${postId}/getData`;

      try {
        const response = await axios.get(apiUrl);
        if (response.status === 200) {
          this.post = response.data;
          this.isLoading = false;
        }
      } catch (error) {
        this.$toast.error(error.message);
        this.isLoading = false;
      }
    },
    goToTagPosts(tag) {
      if (this.$route.params.tagName !== tag) {
        this.$router.push({ name: "TagPosts", params: { tagName: tag } });
      }
    },
    goToCategoryPosts(categoryId) {
      if (this.$route.params.categoryId !== categoryId) {
        this.$router.push({
          name: "CategoryPosts",
          params: { categoryId: categoryId },
        });
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
    this.fetchPostDetails();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style scoped>
.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;

}

.circle {
  width: 30px;
  height: 30px;
  border: 5px solid #f0a500;
  border-top-color: transparent;
  border-radius: 50%;
  background-color: transparent;
  animation: spin 1s linear infinite, fill 2s ease-in-out infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes fill {
  0%,
  100% {
    background-color: transparent;
  }
  50% {
    background-color: transparent;
  }
}
</style>
